
import * as React from "react"
import * as Models from "./models"
import { useOptions, useWindowSize } from "./common"
export function useSignleSelect<T, V extends Models.ItemValue>(props: Models.SingleProps<T, V>): Models.DropDownState<T, V> {
    const [value, setValue] = React.useState<V>(props.value);
    const [showOptions, setShowOptions] = React.useState(false);
    const options = useOptions(props.options);
    const windowSize = useWindowSize();

    React.useEffect(() => {
        setValue(props.value || null)
    }, [props.value])

    React.useEffect(() => {
        setShowOptions(false)
    }, [windowSize.height, windowSize.width])

    const displayValue = React.useMemo(() => {
        
        if (!value)
            return null;

        var option = options.filter(x => x.itemValue === value)[0];

        return !option ? "unknown" : option.itemText;
    }, [options, value])
    
    const optionsTitle = "Select " + props.label;

    return {
        options,
        displayValue,
        optionsTitle,
        showOptions: showOptions,
        onShowOptions: () => setShowOptions(true),
        onHideOptions: () => {
            setShowOptions(false)
        },
        onChange: (data) => {
            if (!data.itemValue)
                return;
            
            props.onChange(data.itemValue, options.filter(x => x.itemValue === data.itemValue)[0]);
            setValue(data.itemValue);
            setShowOptions(false);
        },
        isSelected: (option) => {
            if (!option)
                return false;

            return value === option.itemValue;
        }
    }
}

export default useSignleSelect;